import { render, staticRenderFns } from "./workerData.vue?vue&type=template&id=3729d500&"
import script from "./workerData.vue?vue&type=script&lang=js&"
export * from "./workerData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports